/**
 * Asynchronously loads the component for HomePage
 */

 import { lazyLoad } from 'utils/loadable';

 export const BlogPages = lazyLoad(
   () => import('./index'),
   module => module.BlogPages,
 );
 